import {roundCorners} from 'svg-round-corners';
import {move, horizontal, vertical} from '@packages/utilities/svg-path';

import type {Box} from '@packages/utilities/box';

const createSVGBox = ({
  left = 0,
  top = 0,
  width,
  height,
}: {
  left: Box['left'];
  top: Box['top'];
  width: Box['width'];
  height: Box['height'];
}) => {
  return [
    move(left, top),
    horizontal(width),
    vertical(height),
    horizontal(-width),
    'z',
  ].join('');
};

export const createCutout = (
  ...cutouts: Array<Box & {borderRadius?: number}>
) => {
  return cutouts
    .map(({left, top, width, height, borderRadius = 0}) => {
      const svgBox = createSVGBox({left, top, width, height});
      return roundCorners(svgBox, borderRadius).path;
    })
    .join('');
};
